import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgIcDelete({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M20.77 5.096h-4.434v-.879C16.336 2.988 15.348 2 14.12 2H9.552c-1.251 0-2.24.988-2.24 2.217v.879H2.857A.844.844 0 0 0 2 5.952c0 .483.373.856.856.856h1.383v12.996A2.216 2.216 0 0 0 6.5 22h10.627c1.229.022 2.217-.966 2.26-2.196V6.786h1.384a.844.844 0 0 0 .856-.856.868.868 0 0 0-.856-.834ZM9.004 4.217c-.022-.285.198-.505.483-.527h4.633c.285-.021.505.198.527.483v.945H9.003v-.9Zm1.142 13.415a.844.844 0 0 1-.856.856.844.844 0 0 1-.857-.856v-7.575c0-.483.374-.856.857-.856s.856.373.856.856v7.575Zm5.071 0a.844.844 0 0 1-.856.856.844.844 0 0 1-.856-.856v-7.575c0-.483.373-.856.856-.856s.856.373.856.856v7.575Z"
                fill="#297A71"
            />
        </svg>
    )
}
SvgIcDelete.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgIcDelete
